import React from 'react';
import { Link } from "react-router-dom";
import paths from '../../routes/paths';


export default function ContactPage() {
    return (
        <React.Fragment>
            <div className="py-12">
            <div className="navbar ">
        <div class="navbar-start"></div>
        <div class="navbar-center lg:flex">
          <ul class="menu menu-horizontal">
            <li className="p-1">
              <Link to={paths.home}>Home</Link>
            </li>
            <li>
              <a href="">Shop</a>
            </li>
            
            <li className="p-1">
              <Link to={paths.contact}>Contact</Link>
            </li>
          </ul>
        </div>
        <div className="navbar-end"></div>
      </div>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="lg:text-center">
                    <p className="mt-2 text-3xl font-bold leading-8 tracking-tight sm:text-4xl">
                        Contact
                    </p>
                    <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
                        
                    </p>
                </div>
                <div className="mt-10">
                    <dl className="space-y-10 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10 md:space-y-0">
                        <div>
                            <h2 className="font-bold text-xl">Facebook</h2>
                            <p><a href='https://www.facebook.com/NextGadgetShopMM'>https://www.facebook.com/NextGadgetShopMM</a></p>
                        </div>
                        <div>
                            <h2 className="font-bold text-xl">Instagram</h2>
                            <p><a href='https://instagram.com/nextgadgetshop?igshid=YmMyMTA2M2Y='>https://instagram.com/nextgadgetshop</a></p>
                        </div>
                        <div>
                            <h2 className="font-bold text-xl">Phone</h2>
                            <p>09-89833333</p>
                        </div>
                        <div>
                            <h2 className="font-bold text-xl">Email</h2>
                            <p>nextgadgetshop@gmail.com</p>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
       
        
        
          </React.Fragment >
    )
}

